// extracted by mini-css-extract-plugin
export default {"cls1":"KuPc3r06AG72HDOONKyE","cls2":"NbjcYRRBbJ6XMf7Xajpb KuPc3r06AG72HDOONKyE"};